module.exports = "images/doc-activity-add-1.b71913ce56f1739d44cca10daa8c82b1.png";